<div class="modal-body text-center">
    @if (title) {
        <p>{{ title }}</p>
    }
    @if (content) {
        <div [innerHTML]="content | safeHtml"></div>
    }
    <button type="button" class="btn btn-default" (click)="decline()">{{ declineText }}</button>
    <button type="button" class="btn btn-primary ms-2" (click)="confirm()">{{ confirmText }}</button>
</div>
